// extracted by mini-css-extract-plugin
module.exports = {"u_skip":"MyhouseLayout_u_skip__Q41Su","blind":"MyhouseLayout_blind__f6vCB","hidden":"MyhouseLayout_hidden__2TesW"};